<div class="container-fluid estimate-tunnel" *ngIf="!loadingData">
  <div class="row">
    <div class="col p-0 mr-0 mr-sm-3">
      <div class="row no-gutters">
        <div class="col-12">
          <jhi-alert></jhi-alert>
          <jhi-alert-error></jhi-alert-error>
        </div>
        <div *ngIf="!(offer?.isQuotation || false) && quotationMessages.length > 0 && errorMessages.length === 0" class="col-12 alert alert-warning" role="alert">
          <span class="m-2" jhiTranslate="ESTIMATION_TUNNEL.MESSAGE.NO_PRICING_AVAILABLE"></span>
          <ul>
            <li *ngFor="let message of quotationMessages">{{ message }}</li>
          </ul>
        </div>
        <div *ngIf="errorMessages.length > 0" class="col-12 alert alert-danger" role="alert">
          <span class="m-2" jhiTranslate="ERROR.SOME_ELEMENTS_ARE_INVALID"></span>
          <ul>
            <li *ngFor="let message of errorMessages">{{ message }}</li>
          </ul>
        </div>
      </div>
      <jhi-bary-outlet-tabs
        [stepper]="true"
        class=""
        [steps]="STEPS"
        [active]="activeIndex"
        (activeChange)="activeIndex = $event"
        (activateEvent)="onActivate($event)"
      ></jhi-bary-outlet-tabs>
    </div>
    <div class="col-12 col-lg-auto p-0 mb-3 w-305px mt-3 mt-lg-0">
      <jhi-estimation-price
        [offer]="offer"
        [transport]="transport"
        [transportForm]="transportForm"
        [isLoadingData]="loadingData"
        [hasNextStep]="STEPS[activeIndex].hasNextStep"
        [hasPreviousStep]="STEPS[activeIndex].hasPreviousStep"
        [lastEstimate]="lastEstimate"
        [insuranceIncluded]="insuranceIncluded"
        (cancelEvent)="cancel()"
        (nextEvent)="next($event)"
        (previousEvent)="previous()"
        (updateOfferEvent)="loadOfferDataFromTransport($event)"
        [disabled]="validationResult!.length > 0"
        mdbSticky
        stickyAfter=".navbar"
      ></jhi-estimation-price>
    </div>
  </div>
</div>
